import classNames from 'classnames'
import PropTypes from 'prop-types'
import { createPortal } from 'react-dom'
import { Popup } from 'semantic-ui-react'

import styles from './Tooltip.module.css'

export const BLACK = 'BLACK'
export const YELLOW = 'YELLOW'
export const WHITE = 'WHITE'

const Tooltip = ({
  className,
  content,
  color,
  open,
  pinnedToViewport,
  ...rest
}) => {
  if (pinnedToViewport) {
    if (!open) {
      return null
    }

    return createPortal(
      <div
        className={classNames(
          'tooltip',
          'popup',
          styles.pinnedPanel,
          {
            [styles.black]: color === BLACK,
            [styles.yellow]: color === YELLOW,
            [styles.white]: color === WHITE,
          },
          className,
        )}
      >
        {content}
      </div>,
      document.body,
    )
  }

  return (
    <Popup
      className={classNames(
        styles.Tooltip,
        {
          [styles.black]: color === BLACK,
          [styles.yellow]: color === YELLOW,
          [styles.white]: color === WHITE,
        },
        className,
      )}
      content={content}
      open={open}
      {...rest}
    />
  )
}

Tooltip.propTypes = {
  className: PropTypes.string,
  content: PropTypes.node,
  color: PropTypes.string,
  open: PropTypes.bool,
  pinnedToViewport: PropTypes.bool,
}

Tooltip.defaultProps = {
  className: '',
  content: null,
  color: BLACK,
  open: undefined,
  pinnedToViewport: false,
}

export default Tooltip
